import { Component } from "@angular/core";

@Component({
  selector: "app-enterprise1-content",
  templateUrl: "enterprise1-content.component.html",
})
export class Enterprise1ContentComponent {}
